import { render, staticRenderFns } from "./m-chainSearch.vue?vue&type=template&id=37bddfb2&scoped=true&"
import script from "./m-chainSearch.vue?vue&type=script&lang=ts&"
export * from "./m-chainSearch.vue?vue&type=script&lang=ts&"
import style0 from "./m-chainSearch.vue?vue&type=style&index=0&id=37bddfb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bddfb2",
  null
  
)

export default component.exports